<template>
  <section class="index">
    <div class="container">
      <div class="gc-page-container">
      <div class="container-center">
        <div class="shuomin">答题成功获得现金，失败则获得10个点子数</div>
          <section class="gc-page" v-if="isShowBlankCard">
            <!-- 没有进行中问卷卡片 -->
            <div class="noQ">
              <div class="noQ-div">
                  <p>哦呦，目前暂无适合您的现金问卷呢</p>
                  <p>但是有更加惊喜的问卷在等着您</p>
                  <p class="noQ-link">现金奖励即刻到账</p>
                  <p>24小时随时可以答题</p>
                  <div class="noQ-btn" @click="onTapJoinBtn">立刻参加</div>
              </div>
              <div></div>
            </div>
          </section>
          <section class="gc-page" v-for="(item,index) in listData" :key="item.surveyId">
            <template v-if="item.done">
              <!-- 已完成 -->
              <div class="gc-headImg-ctx">
                <img class="gc-headImg" src="../assets/img/cash.png" />
              </div>
              <div class="gc-page-top done">
                <!-- <div class="gc-money">{{ item.prMoney }}<span>元</span></div> -->
                <div class="done-status">{{ item.status }}</div>
              </div>
              <div class="gc-page-center">
                <p class="gc-nickname">{{ item.cashPrId }}</p>
                <p class="gc-title">{{ item.prTitle }}</p>
                <p class="gc-subtitle">{{ item.prDescribe }}</p>
              </div>
              <div class="gc-qrtime">{{item.addTime}}</div>
              <div class="gc-qrcode">
                <div class="gc-qrcode-text" @click="onTapEnterBtn(index)">详情</div>
              </div>
            </template>
            <template v-else>
              <!-- 进行中 -->
              <div class="gc-headImg-ctx">
                <img class="gc-headImg" src="../assets/img/WechatIMG16.jpeg" />
              </div>
              <!-- <div class="gc-page-top ing">
                <div class="ing-status"><span>{{ item.surveyMoney }}</span>元</div>
              </div> -->
              <div class="gc-page-top ing">
                <div class="gc-money">{{ item.surveyMoney }}<span>元</span></div>
                <div class="done-status">&nbsp;</div>
              </div>
              <div class="gc-page-center">
                <p class="gc-nickname">{{ item.surveyId }}</p>
                <p class="gc-title">{{ item.surveyName }}</p>
                <p class="gc-subtitle">{{ item.surveyDesc }}</p>
              </div>
              <div class="gc-qrtime">结束时间：{{item.endTime}}</div>
              <div class="gc-qrcode">
                <div class="gc-qrcode-text" @click="onTapEnterBtn(index)">进入问卷</div>
              </div>
            </template>
          </section>
      </div>
      </div>
    </div>

    <card v-if="isShow" type="1" :dialog="dialog" @closeDialog="closeDialog" @tixian="speedTixian"/>
  </section>
</template>

<script>
import { getCookie } from '../utils';
import Card from '../components/DialogCard';

export default {
  components: {
    Card
  },

  data() {
    return {
      isShow: false,
      listData: [],
      dialog: {},
      isShowBlankCard: false
    }
  },

  mounted() {
    this.request();
  },

  methods: {
    // 加速提现
    speedTixian() {
      // this.isShow = false;
      // localStorage.setItem('cashPrId', this.dialog.cashPrId);
      // this.$router.push({ path: '/award' });
    },

    // 点击进入问卷
    onTapEnterBtn(index) {
      if (this.listData[index].done) {
        // 已完成，弹窗
        let unionId = getCookie('unionId');
        this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/questionnairedetail/getCompletedListForPc', { params: { param: unionId, pid: this.listData[index].cashPrId}}).then(res => {
          console.log(res);
          this.dialog = res.data.data;
          this.isShow = true
        })
      }else {
        // 进行中，跳页面
        // window.open(this.listData[index].surveyUrl);
        window.location.href = this.listData[index].surveyUrl;
      }
    },

    // 进行中问卷
    request() {
      let unionId = getCookie('unionId');
      this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/distrionwj/getAllInPro', { params: { param : unionId}}).then(res => {
          console.log('进行中');
          console.log(res);
        let list = [];
        // 有进行中问卷
        res.data.data.forEach(item => {
          let value = {};
          value.done = false;
          value.surveyId = item.surveyId;
          value.surveyName = item.surveyName;
          value.surveyDesc = item.surveyDesc;
          value.surveyMoney = item.surveyMoney;
          value.prUrl = item.prUrl;
          value.surveyUrl = item.surveyUrl;
          value.endTime = item.endTime;
          value.surveyOpenId = item.surveyOpenId;
          list.push(value);
        });
        if (list.length == 0) {
          this.isShowBlankCard = true;
        }
        this.listData = list;
        this.requestDone();
      })
    },

    // 已完成问卷
    requestDone() {
      let unionId = getCookie('unionId');
      this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/distrionwj/getAllComPro', { params: { param : unionId}}).then(res => {
        console.log('已完成');
        console.log(res)
        let list = [];
        res.data.data.forEach(item => {
          let value = {};
          value.done = true;
          value.cashPrId = item.cashPrId;
          value.addTime = item.addTime;
          value.extrabonus = item.extrabonus;
          value.failmsg = item.failmsg;
          value.link = item.link;
          value.orderNo = item.orderNo;
          value.prDescribe = item.prDescribe;
          value.prMoney = item.prMoney;
          value.prTitle = item.prTitle;
          value.ssiPrId = item.ssiPrId;
          value.unionId = item.unionId;
          if (item.status == 0) {
            value.status = '已申请';
          }else if (item.status == 1) {
            value.status = '已提现';
          }else {
            value.status = '已失效';
          }

          list.push(value);
        })
        this.listData = this.listData.concat(list);
      })
    },

    closeDialog() {
      this.isShow = false
    },

    onTapJoinBtn() {
      let unionId = getCookie('unionId');
      let params =  { param: unionId }
      this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/distrionwj/getSsiQuestionnaireForPc', { params }).then(res => {
          window.location.href = res.data.data.link;
      })
    }
  }
}
</script>

<style scoped>

.index .gc-qrcode-img{
  width:125px;
  height:125px;
  margin: 20px auto;
}
.index .wxssk{
  font-size: 12px;
  color: #666666;
  text-align: center;
}
.index .gc-qrcode-ctx{
  width: 160px;
  height: 200px;
  background: #FFFFFF;
  border: 1px solid #EFEFEF;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.08);
  border-radius: 2px;
}
.index .gc-qrcode{
  position: absolute;
  bottom: 20px;
  right: 15px;
}

.index .gc-qrtime {
  position: absolute;
  bottom: 20px;
  left: 15px;
  font-size: 10px;
  color: #999;
}
.index .gc-qrcode-text{
  font-size: 13px;
  color: #959499;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  /* width: 60px; */
  padding-left: 10px;
  padding-right: 10px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  float: right;
  margin-top: 10px;
  cursor: pointer;
}
.index .gc-qrcode-text:hover{
  background: #C9C9CE;
  border-color: #C9C9CE;
  color: #fff;
}
.index .gc-page{
  float:left;
  /* margin-right: 20px; */
  margin-left: 10px;
  margin-right: 10px;
}
.index .gc-category{
  position: absolute;
  right: 15px;
  top:15px;
  z-index: 2;
  border-radius: 100px;
  background-color: rgba(0,0,0,.7);
  font-size: 11px;
  color: #FFFFFF;
  padding:5px;
}
.index .gc-page-bottom{
  position: absolute;
  bottom: 20px;
  z-index: 2;
  left: 15px;
  height: 16px;
  line-height: 16px;
  width: 150px;
  font-size: 12px;
  color: #9B9B9B;
}
.index .gc-headImg-ctx{
  position: absolute;
  top: 125px;
  left: 15px;
  z-index: 2;
  width:32px;
  height:32px;
}
.index .gc-headImg{
  width:32px;
  height:32px;
  border-radius: 32px;
  border: 2px solid #FFFFFF;
}
/* .index .gc-page-top{
  width: 280px;
  height: 140px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
} */
.index .gc-page-top{
  width: 280px;
  height: 140px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* justify-content: center; */
  justify-content: flex-end;
}
.index .gc-page-center{
  position: relative;
  padding:15px;
  padding-top: 25px;
}
.index .gc-nickname{
  font-size: 13px;
  color: #666666;
  margin-bottom: 15px;
}
.index .gc-title{
  font-size: 15px;
  color: #333;
  margin-bottom: 12px;
  line-height: 22px;
}
.index .gc-subtitle{
  font-size: 12px;
  color: #888888;
  line-height: 18px;
  /* max-height: 54px; */
  overflow: hidden;
}
.index .gc-page{
  width: 280px;
  height: 360px;
  background: #FFFFFF;
  /* cursor: pointer; */
  position: relative;
  margin-bottom: 20px;
}
.index .gc-page:hover{
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.08);
}
.index .container {
  min-height: 540px;
}
.index .gc-page-top img {
  width: 100%;
  height: 100%;
  background: gray;
}

.noQ {
	display: block;
	padding-top: 20px;
}

.noQ p {
	font-size: 14px;
	color: #666;
	text-align: center;
	line-height: 28px;
}

.noQ-div {
	width: 260px;
	height: 196.48px;
	margin: 0 auto;
	background-size: 360px 196.48px;
	padding-top: 22px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.noQ .noQ-link {
	color: #65AE71;
	border-bottom: 3px double #65AE71;
}

.noQ-btn {
	font-size: 16px;
	margin-top: 10px;
	color: white;
	/* background: #DF7F7D; */
	background:#65AE71;
	height: 40px;
	width: 120px;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
  cursor: pointer;
}

.noQ div:nth-of-type(2) {
	width: 47px;
	height: 77px;
	margin: 10px auto 0;
	background: url(../assets/img/zhanwuicon@2x.png) center no-repeat;
	background-size: 47px 77px;
}
.done {
  background: #9FC2E2;
}

.ing {
  background: #D4B7B5;
}

/* .done-status {
  position: relative;
  left: 110px;
  top: 118px;
  color: white;
} */

.ing-status {
  position: relative;
  left: 115px;
  top:  110px;
  color: white;
}

.ing-status span {
  font-size: 160%;
  margin-right: 4px;
}


/*  */
.shuomin {
  color: #999;
  font-size: 14px;
  margin: 20px 0px;
  padding-left: 10px;
  width: calc(100% - 10px);
}

.gc-page-container {
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin: 0 auto;
}

.index .container-center{
  margin:0 auto;
  overflow: hidden;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: flex-start;
}

/* 手机 */
@media screen and (max-width: 768px) {
	.index .container-center {
		width: 300px;
	}
}

/* Pad */
@media screen and (min-width: 768px) and (max-width: 1023px) {
	.index .container-center {
		width: 600px;
	}
}

/* 中屏幕电脑 */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
	.index .container-center {
		width: 900px;
	}
}

/* 大屏幕电脑 */
@media screen and (min-width: 1200px) {
	.index .container-center {
		width: 1200px;
	}
}

.done-status {
  /* position: relative;
  left: 105px;
  top: 8px; */
    /* width: 280px;
  height: 360px; */
  color: white;
  display: flex;
  flex-direction: row-reverse;
  margin-right: 5px;
  margin-bottom: 5px;
}

.gc-money {
  color: white;
  font-size: 80px;
  text-align: center;
  margin-bottom: -10px;
  /* font-weight: 545; */
}

.gc-money span {
  font-size: 20px;
  margin-left: 5px;
  /* font-weight: normal; */
}
</style>
